import React, { useState } from 'react'
import Loader from 'components/Loader'
import { Button, Box, Typography, Grid, useTheme } from '@mui/material'
import { fetchGetEmployerUsers } from 'src/redux/users'
import { useSelector, useDispatch } from 'react-redux'
import { AdminUsersTable } from 'components/Table/AdminUsersTable'
import EmployerUserDrawer from 'components/Drawers/EmployerUserDrawer'

const Users = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const { loading, users } = useSelector(state => state.users)
  const [isEditDrawerOpen, setEditDrawerOpen] = useState(false)
  const [selectedEmployerUser, setSelectedEmployerUser] = useState(null)

  const handleOpenEditDrawer = employerUser => {
    setSelectedEmployerUser(employerUser)
    setEditDrawerOpen(true)
  }

  const handleCloseEditDrawer = () => {
    setSelectedEmployerUser(null)
    setEditDrawerOpen(false)
  }

  const usersData = users.map(user => ({
    id: user.user.id,
    email: user.user.email,
    firstName: user.user.firstName,
    lastName: user.user.lastName,
    isEmployerAdmin: user.isEmployerAdmin === true ? 'Yes' : 'No',
    employer: user.employer.name,
    actions: (
      <Button variant='outlined' onClick={() => handleOpenEditDrawer(user)}>
        Edit
      </Button>
    ),
  }))
  React.useEffect(() => {
    dispatch(fetchGetEmployerUsers())
  }, [dispatch])

  return (
    <>
      <Box sx={{
        width: '100%',
        backgroundColor: theme.palette.background.dark,
        borderRadius: '0px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        mb: 4,
        pt: 0,
        pb: { xs: 3, md: 4 },
        px: 0,
      }}>
        <Box sx={{ maxWidth: '91.666667%', mx: 'auto', p: { xs: 2, md: 3 } }}>
          <Grid container spacing={0} sx={{ px: 0 }}>
            <Grid item xs={12} md={8} sx={{ pl: 0 }}>
              <Typography variant='h5' sx={{ 
                color: 'white',
                fontWeight: 'bold',
                mb: 1,
                pl: 0
              }}>
                Employer Users
              </Typography>
              <Typography variant='caption' sx={{ 
                color: 'rgba(255,255,255,0.7)',
                display: 'block',
                mb: { xs: 2, md: 0 },
                whiteSpace: 'normal',
                wordBreak: 'normal',
                pl: 0
              }}>
                Manage user accounts and permissions.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {loading ? <Loader /> : <AdminUsersTable data={usersData} />}
      <EmployerUserDrawer
        open={isEditDrawerOpen}
        onClose={handleCloseEditDrawer}
        initialValues={selectedEmployerUser}
        type='edit'
      />
    </>
  )
}
export default Users
